import { useState, useEffect, useMemo } from 'react';

import { useNavigate } from 'react-router-dom';

export const usePath = (path) => {
  const navigate = useNavigate();
  const [pathname, setPathname] = useState(path);

  useEffect(() => {
    navigate(pathname);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const router = useMemo(() => {
    return {
      pathname,
      searchParams: new URLSearchParams(),
      navigate: (path) => {
        setPathname(String(path));
      },
    };
  }, [pathname]);

  return [pathname, setPathname, router];
};
